import { css } from '@flipster/styled-system/css';

import Announcement from './sections/Announcement';
import Designed from './sections/Designed';
import SpotHero from './sections/Hero/SpotHero';
import { Faq } from './sections/faq';

const SpotMainPage = () => {
  return (
    <main className={css({ pos: 'relative', overflowX: 'hidden', mb: { base: 56, tablet: 150 } })}>
      <SpotHero />
      <Announcement />
      <Designed />
      <Faq />
    </main>
  );
};

export default SpotMainPage;
